import { devApiUrl, prodApiUrl } from "@/globals";
import { api } from "roboflex-thalamus-request-handler/dist";
import { sso } from "roboflex-thalamus-sso-lib";

export class NotificationService {
    constructor(buildMode) {
        this.buildMode = buildMode;
    }

    async getNotificacoes() {
        const usuarioLogado = await sso.getUsuarioLogado();
        try {
            var response;
            if (this.buildMode == "development" || this.buildMode == "staging") {
                response = await api.get(`${devApiUrl}notificacoes/usuario/${usuarioLogado.id}`);
            } else {
                response = await api.get(`${prodApiUrl}notificacoes/usuario/${usuarioLogado.id}`);
            }

            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
    async lerNotificacao(ids) {
        try {
            var response;
            if (this.buildMode == "development" || this.buildMode == "staging") {
                response = await api.post(`${devApiUrl}notificacoes/ler`, { notificacao: ids });
            } else {
                response = await api.post(`${prodApiUrl}notificacoes/ler`, { notificacao: ids });
            }
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
    async apagarNotificacoes(ids) {
        try {
            var response;
            if (this.buildMode == "development" || this.buildMode == "staging") {
                response = await api.post(`${devApiUrl}notificacoes/excluir`, { notificacao: ids });
            } else {
                response = await api.post(`${prodApiUrl}notificacoes/excluir`, { notificacao: ids });
            }
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}
